import React, { useState } from "react";
import { Grid } from "@mui/material";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import DashboardSidebar from "./DashboardSidebar";
import { addIcon, cardLinkIcon } from "../assets";
import "../styles/dashboard.styles.css";
import "react-toastify/dist/ReactToastify.css";

function CardAdd() {
  const [newTool, setNewTool] = useState({
    backgroundImageUrl:
      "https://res.cloudinary.com/dtkegph1g/image/upload/v1699363876/ffffff_1_dwjtpc.png",
    toolTag: "tag",
    toolTitle: "title",
    toolType: "new",
    toolLink: "",
    toolDescription: "your discription",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewTool({
      ...newTool,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://devuse-fullstack.vercel.app/tools/add",
        newTool
      );

      toast.success("Tool added successfully");
      setNewTool({
        backgroundImageUrl:
          "https://res.cloudinary.com/dtkegph1g/image/upload/v1699363876/ffffff_1_dwjtpc.png",
        toolTag: "",
        toolTitle: "",
        toolLink: "",
        toolType: "",
        toolDescription: "",
      });
    } catch (error) {
      if (error.response.status === 400) {
        toast.error("tools already exists. ");
      } else {
        toast.error("An unexpected error occurred while adding the tool.");
      }
    }
  };

  return (
    <div>
      <ToastContainer />
      <Grid container justifyContent={"center"}>
        <Grid item lg={11.5}>
          <Grid lg={1}>
            <DashboardSidebar />
          </Grid>
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"80vh"}
          >
            <Grid item lg={4.5}>
              <Grid container alignItems={"center"}>
                <Grid xs={10} sm={4.9} md={4.2} lg={8}>
                  <div className="card">
                    <div className="card_img_container">
                      <img src={newTool.backgroundImageUrl} alt="tools" />
                    </div>
                    <div className="card_content_container">
                      <div className="tag">
                        <div className="tag_width">
                          <span>{newTool.toolTag}</span>
                        </div>
                        {newTool.toolType && (
                          <div className="tool-version-dashboard">{newTool.toolType}</div>
                        )}
                      </div>
                      <a
                        href={newTool.toolLink}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="card_link_container">
                          <h1>{newTool.toolTitle}</h1>
                          <img
                            src={cardLinkIcon}
                            className="link_image"
                            alt="link-icon"
                          />
                        </div>
                      </a>
                      <p>{newTool.toolDescription}</p>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={11} lg={4}>
              <div className="l-input-container">
                <form onSubmit={handleSubmit}>
                  <input
                    type="text"
                    placeholder="add tool img url here"
                    required
                    name="backgroundImageUrl"
                    value={newTool.backgroundImageUrl}
                    onChange={handleChange}
                  />
                  <input
                    type="text"
                    required
                    name="toolTag"
                    value={newTool.toolTag}
                    onChange={handleChange}
                    placeholder="add tool tag here"
                  />
                  <input
                    type="text"
                    required
                    name="toolType"
                    value={newTool.toolType}
                    onChange={handleChange}
                    placeholder="add tool type here"
                  />
                  <input
                    type="text"
                    required
                    name="toolTitle"
                    value={newTool.toolTitle}
                    onChange={handleChange}
                    placeholder="add tool title here"
                  />
                  <input
                    type="text"
                    required
                    name="toolLink"
                    value={newTool.toolLink}
                    onChange={handleChange}
                    placeholder="add tool link here"
                  />
                  <input
                    type="text"
                    required
                    name="toolDescription"
                    value={newTool.toolDescription}
                    onChange={handleChange}
                    placeholder="add tool discription here"
                  />
                  <button type="submit">
                    <img src={addIcon} alt="add form icon" />
                  </button>
                </form>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default CardAdd;
